/* global gform, paypal, gform_ppcp_form_editor_strings, GFPayPalCheckoutUtils, HideSettings, SetFieldProperty, GetFieldsByType, GetSelectedField */
/* eslint-disable no-alert */

import './utilities.js';

window.GFPPCPFormEditor = null;

(function ($, strings) {
	window.GFPPCPFormEditor = function () {
		const self = this;
		const subscriptionsData = strings.form_data[ form.id ];

		self.paypalButtons = false;

		self.isRenderingButtons = false;

		self.isLegacy = strings.is_legacy === 'true';

		self.subscriptions = {
			feedExists: subscriptionsData.has_feed === 'true',
			unsupportedPaymentMethod( value ) {
				return $.inArray( value, subscriptionsData.supported_methods ) === -1;
			},
			showNotice: subscriptionsData.show_notice === 'true',
		};

		self.fieldContainer = '.gform_ppcp_custom_card_fields';

		self.init = function() {
			self.utils = GFPayPalCheckoutUtils;
			self.hooks();

			self.bindFieldAdded();
			self.bindLoadFieldSettings();
			self.bindSetPaymentMethod();
			self.maybeLoadSubscriptionsNotice();
		};

		self.hooks = function() {
			gform.addAction( 'gform_post_load_field_settings', function( [ field, form ] ) {
				if ( 'paypal' === field.type ) {
					// Render the Smart Payment Buttons.
					self.renderSmartPaymentButtons( field );
					self.bindRerenderSmartPaymentButtons( field );

					// Hide #field_settings when the api is not initialized.
					// This is called right after the settings are shown. So that makes it feel like there's no settings.
					if ( strings.initialize_api === '' ) {
						HideSettings( 'field_settings' );
					}

					$( '#field_paypal_default_payment_method' ).val( field[ 'defaultPaymentMethod' ] ).on( 'change', function() {
						const newMethod = $( this ).val();
						$( '.gform_ppcp_payment_method select' ).val( newMethod );
						// Update the default payment method in the global form variable.
						SetFieldProperty( 'defaultPaymentMethod', newMethod );
					} );

					$( '.input_placeholders_setting' ).on( 'input propertychange', '.input_placeholder', function() {
						const inputId = $( this ).closest( '.input_placeholder_row' ).data( 'input_id' );

						if ( $( this ).attr( 'id' ).indexOf( '.5' ) === -1 ) {
							$( '#input_' + inputId.toString().replace( '.', '_' ) ).text( this.value );
						}
					} );

					// Remove JCB card option.
					$( '.credit_card_setting ul li' ).each( function( i, elem ) {
						if ( $( elem ).children( 'input' ).val() === 'jcb' ) {
							$( elem ).hide();
						}
					} );

					self.togglePaymentMethodFields( field.methods, true );
				} else {
					self.paypalButtons = false;
				}
			} );

			gform.addFilter( 'gform_form_editor_can_field_be_added', function( result, type ) {
				if ( type !== 'paypal' || GetFieldsByType( [ 'paypal' ] ).length < 1 ) {
					return result;
				}

				alert( strings.only_one_paypal_field );

				return false;
			} );
		};

		self.bindFieldAdded = function () {
			$( document ).bind(
				'gform_field_added',
				function ( event, form, field ) {
					if ( field.type === 'paypal' ) {
						// Render the Smart Payment Buttons.
						self.renderSmartPaymentButtons( field );
					}
				}
			);
		};

		self.renderSmartPaymentButtons = function( field ) {
			const buttonsContainerID = '#gform_ppcp_smart_payment_buttons';
			const $buttonsContainer = $( buttonsContainerID );

			if ( self.isRenderingButtons || ! $buttonsContainer.length || typeof window.paypal === 'undefined' ) {
				return;
			}

			self.isRenderingButtons = true
			$buttonsContainer.addClass( field.buttonsSize );
			$buttonsContainer.html( '' );

			const buttonParams = {
				style: {
					layout: field.buttonsLayout,
					color: field.buttonsColor,
					shape: field.buttonsShape,
				},
				onInit( data, actions ) {
					actions.disable();
				},
			};

			if ( this.subscriptions.feedExists ) {
				buttonParams.createSubscription = function() {
					return false;
				};
			}

			self.maybeClosePaypalButton();

			self.paypalButtons = window.paypal.Buttons( buttonParams );
			self.paypalButtons.render( buttonsContainerID ).then(
				function() {
					self.isRenderingButtons = false;
				}
			);
		};

		/**
		 * Properly close Paypal button.
		 */
		self.maybeClosePaypalButton = function() {
			if ( self.paypalButtons && 'undefined' !== typeof self.paypalButtons.close ) {
				self.paypalButtons.close();
			}
		};

		self.bindRerenderSmartPaymentButtons = function ( field ) {
			$( '#smart_payment_buttons_container select' ).off( 'change' ).on(
				'change',
				function () {
					const setting = $( this ).attr( 'id' );
					const value = $( this ).val();

					SetFieldProperty( setting, value );
					self.renderSmartPaymentButtons( field );
				}
			);
		};

		/**
		 * Restore original settings fields.
		 *
		 * @param field
		 */
		self.resetSettingsFields = function( field ) {
			self.paypalButtons = false;

			// Hide Paypal related fields.
			self.hidePaypalFields();

			// Remove Paypal class from fields.
			self.getCreditCardFields( true ).removeClass( 'paypal' );

			// Restore JCB card option.
			$( '.credit_card_setting ul li:hidden' ).show();
		};

		self.bindLoadFieldSettings = function() {
			$( document ).bind( 'gform_load_field_settings', function( event, field, form ) {
				if ( field.type !== 'paypal' ) {
					self.resetSettingsFields( field );
					return;
				}

				self.getCreditCardFields().addClass( 'paypal' );

				// If the field was previously set with an account that supports custom card fields,
				// but now switch to another account doesn't, we dynamically update the methods here.
				if ( strings.is_custom_card_fields_supported === '' ) {
					field.methods = [ 'PayPal Checkout' ];
					SetFieldProperty( 'methods', field.methods );
				}

				for ( let i in field.methods ) {
					if ( field.methods[ i ] === 'Credit Card' ) {
						$( '#paypal_payment_custom_card_fields' ).prop( 'checked', true );
					} else {
						$( '#paypal_payment_smart_payment_buttons' ).prop( 'checked', true );
					}
				}

				for ( let i in field.creditCards ) {
					if ( ! field.creditCards.hasOwnProperty( i ) ) {
						continue;
					}

					$( '#field_credit_card_' + field.creditCards[ i ] ).prop( 'checked', true );
				}

				// Add the toggle to the cardholder name sub-label.
				const activeImage = 'active1.png';
				const inactiveImage = 'active0.png';

				var imagesUrl = strings.imgurl,
					input = field[ 'inputs' ][ 4 ],
					isHidden = self.getParameter( input.isHidden, false ),
					title = isHidden ? strings.inactive : strings.active,
					img = isHidden ? inactiveImage : activeImage;

				$( '.input_placeholders.paypal tr:eq(4)' ).toggle( ! isHidden );

				$( '.sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(0)' ).prepend( '<td><strong>' + strings.show + '</strong></td>' );
				$( '.sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(1), .sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(2), .sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(3), .sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(5)' ).prepend( '<td></td>' );
				$( '.sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(4)' ).prepend( '<td><img data-input_id=\'' + field[ 'id' ] + '.5\' alt=\'' + title + '\' class=\'input_active_icon cardholder_name\' src=\'' + imagesUrl + img + '\'/></td>' );
				// Toggle Sub-Label disabled status.
				$( '.sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(4) td:eq(2) input' ).prop( 'disabled', isHidden );
				// Allow Cardholder Name to be disabled.
				$( '.sub_labels_setting.paypal .input_active_icon.cardholder_name' ).off( 'click keypress' ).on(
					'click keypress',
					function( e ) {
						e.stopImmediatePropagation();
						let $img = $( this );

						const isActive = $img.attr( 'src' ).indexOf( activeImage ) >= 0;
						const currentImage = isActive ? activeImage : inactiveImage;
						const replacmentImage = isActive ? inactiveImage : activeImage;
						const newSrc = $img.attr( 'src' ).replace( currentImage, replacmentImage );

						$img.attr( 'src', newSrc );

						// Toggle field visibility.
						$( '#input_' + field[ 'id' ] + '_5_container' ).toggle( ! isActive );

						// Toggle Sub-Label disabled status.
						$( '.sub_labels_setting.paypal .field_custom_inputs_ui tr:eq(4) td:eq(2) input' ).prop( 'disabled', isActive );

						// Toggle Placeholder
						$( '#input_placeholder_row_input_' + field[ 'id' ] + '_5' ).toggle( ! isActive );

						SetInputHidden( isActive, input.id );
					}
				);

				// Set up the Smart Payment Button styles.
				const buttonsSettings = [ 'buttonsLayout', 'buttonsSize', 'buttonsShape', 'buttonsColor' ];
				buttonsSettings.forEach( function( e ) {
					$( '#' + e ).val( field[ e ] );
				} );
			} );
		};

		/**
		 * Get settings fields related to credit card payment method.
		 *
		 * @param bool filterByPaypalClass If fields should be filtered by paypal class.
		 *
		 * @returns {*|jQuery|HTMLElement}
		 */
		self.getCreditCardFields = function( filterByPaypalClass ) {
			let $fields = $(
				`
				.input_placeholders_setting,
				.sub_labels_setting,
				.sub_label_placement_setting,
				.credit_card_setting,
				.credit_card_style_setting,
				.label_placement_setting,
				.error_message_setting,
				.css_class_setting
				`
			);

			return self.getParameter( filterByPaypalClass, false ) ? $fields.filter( '.paypal' ) : $fields;
		};

		/**
		 * Toggle fields related to Payment Method
		 *
		 * @param array methods Payment methods array.
		 */
		self.togglePaymentMethodFields = function( methods, isInit ) {
			isInit = self.getParameter( isInit, false );

			const ccValue = 'Credit Card',
				smartButtonsValue = 'PayPal Checkout',
				ccIsSupported = false === this.subscriptions.unsupportedPaymentMethod( ccValue ),
				ccIsVisible = $.inArray( ccValue, methods ) >= 0 && ccIsSupported,
				smartButtonsIsVisible = $.inArray( smartButtonsValue, methods ) >= 0;

			self.toggleCreditCardFields( isInit, ccIsVisible );

			self.toggleSmartButtonFields( isInit, smartButtonsIsVisible, ccIsVisible );

			self.toggleDefaultPaymentMethod( isInit, ccIsSupported );
		};

		/**
		 * Toggle the Credit Card fields.
		 *
		 * @param bool isInit      If this is the init event.
		 * @param bool ccIsVisible If Credit Card fields should be visible.
		 */
		self.toggleCreditCardFields = function( isInit, ccIsVisible ) {
			if ( ccIsVisible ) {
				$( '.ginput_container_custom_card_fields:hidden' ).fadeIn();
				self.getCreditCardFields( true ).filter( ':hidden' ).fadeIn();
			} else {
				$( '.ginput_container_custom_card_fields:visible' ).fadeOut();

				if ( isInit ) {
					self.getCreditCardFields( true ).hide();
				} else {
					self.getCreditCardFields( true ).fadeOut();
				}
			}
		};

		/**
		 * Toggle the Smart Button Fields
		 *
		 * @param bool isInit                If this is the init event.
		 * @param bool smartButtonsIsVisible If Smart Buttons fields should be visible.
		 * @param bool ccIsVisible           If Credit Card fields should be visible.
		 */
		self.toggleSmartButtonFields = function( isInit, smartButtonsIsVisible, ccIsVisible ) {
			if ( smartButtonsIsVisible ) {
				$( '.smart_payment_buttons_settings:hidden' ).fadeIn();
				$( '.smart_payment_buttons_note:hidden' ).fadeIn();
			} else {
				$( '.smart_payment_buttons_settings' ).fadeOut();
				$( '.smart_payment_buttons_note:visible' ).fadeOut();
			}
		};

		/**
		 * If default Payment method field should be shown.
		 *
		 * @param bool ccIsSupported Is the Credit Card field supported.
		 *
		 * @returns {boolean}
		 */
		self.showDefaultPaymentMethod = function( ccIsSupported ) {
			return ! ccIsSupported || $( '.supported_payment_methods input:checked' ).length <= 1;
		};

		/**
		 * Toggle Default Payment Fields visibility.
		 *
		 * @param bool isInit        If this is the initalize event.
		 * @param bool ccIsSupported If credit card fields are supported.
		 */
		self.toggleDefaultPaymentMethod = function( isInit, ccIsSupported ) {
			if ( self.showDefaultPaymentMethod( ccIsSupported ) ) {

				$( '.gform_ppcp_payment_method:visible' ).fadeOut();

				if ( isInit ) {
					$( '.paypal_default_payment_method' ).hide();
				} else {
					$( '.paypal_default_payment_method' ).fadeOut();
				}
			} else {
				$( '.paypal_default_payment_method:hidden' ).fadeIn();
				$( '.gform_ppcp_payment_method:hidden' ).fadeIn();
			}
		};

		/**
		 * Hide Paypal fields when not on Paypal field type.
		 */
		self.hidePaypalFields = function() {
			self.getCreditCardFields( true ).hide();
			$( '.supported_payment_methods' ).hide();
			$( '.paypal_default_payment_method' ).hide();
		};

		/**
		 * Displays inputs for the payment methods selected in the field.
		 *
		 * @param e
		 * @param elem
		 * @return {boolean}
		 */
		self.SetPaymentMethods = function( e, elem ) {
			const methods = GetSelectedField()[ 'methods' ] ? GetSelectedField()[ 'methods' ] : new Array();
			const value = $( elem ).val();

			if ( $( elem ).is( ':checked' ) ) {
				if ( $.inArray( value, methods ) === -1 ) {
					// Add the checked method to the index of methods.
					methods[ methods.length ] = value;
				}
			} else {
				if ( methods.length <= 1 ) {
					alert( strings.must_have_method );

					e.preventDefault();
					return false;
				}

				const index = $.inArray( value, methods );
				if ( index !== -1 ) {
					methods.splice( index, 1 );
				}
			}

			SetFieldProperty( 'methods', methods );

			self.maybeDisplayUnsupportedPaymentMethodMessage( elem, value );

			self.togglePaymentMethodFields( methods );
		};

		/**
		 * Display a form admin message when a selected payment method is not supported by the form's PayPal feeds.
		 *
		 * @since 2.0
		 *
		 * @param {Object} elem DOM element.
		 * @param {string} method The payment method.
		 */
		self.maybeDisplayUnsupportedPaymentMethodMessage = function( elem, method ) {
			const $unsupportedMethod = $( elem );
			const $errorMessage = $( this.fieldContainer ).find( '#gf-paypal-checkout-unsupported-payment-warning' );

			if ( ! $errorMessage.length ) {
				$( this.fieldContainer ).append( $errorMessage );
			}

			if ( this.subscriptions.feedExists && this.subscriptions.unsupportedPaymentMethod( method ) && $unsupportedMethod.is( ':checked' ) ) {
				$errorMessage.show();
			} else {
				$errorMessage.hide();
			}
		};

		/**
		 * Show a notice in the form editor if a subscriptions feed exists and credit cards are selected.
		 */
		self.maybeLoadSubscriptionsNotice = function() {
			if ( ! this.subscriptions.feedExists ) {
				return;
			}

			$( this.fieldContainer ).append( this.utils.subscriptions.getUnsupportedPaymentMethodMarkup( this.isLegacy ) );
			this.subscriptions.notice = this.utils.subscriptions.getNoticeContainer();

			if ( ! this.subscriptions.showNotice ) {
				this.subscriptions.notice.hide();
			}
		};

		self.bindSetPaymentMethod = function () {
			$( '.supported_payment_methods input:checkbox' ).on(
				'click keypress',
				function (e) {
					self.SetPaymentMethods( e, this );
				}
			);
		};

		/**
		 * Checks a parameter if defined, returns the value or the default value.
		 *
		 * @param mixed parameter    The function parameter.
		 * @param mixed defaultValue The default value if not defined.
		 *
		 * @returns mixed
		 */
		self.getParameter = function( parameter, defaultValue ) {
			return 'undefined' === typeof parameter ? defaultValue : parameter;
		};

		self.init();
	};

	$( document ).ready( GFPPCPFormEditor );
})( jQuery, gform_ppcp_form_editor_strings );
